module.exports = __webpack_public_path__ + "images/marketing/peeps/elizabeth_doherty.jpg";